// extracted by mini-css-extract-plugin
module.exports =  {"back-btn":"back-btn--vQliG","backBtn":"back-btn--vQliG"};